module.exports = __webpack_public_path__ + "static/media/american-express-logo.78a87e92.png";